import { CartIcon } from './HomeIcons';

export default function MiniCart({ cartItems, onClose }) {
  const total = cartItems.reduce((sum, i) => sum + i.price * i.qty, 0);

  return (
    <>
      <div className="mini-cart-overlay" onClick={onClose} />
      <div className="mini-cart" role="dialog" aria-label="Mini cart">
        <div className="mini-cart-header">
          <h4>
            <CartIcon className="ui-icon inline-cart-icon" />
            Your Cart ({cartItems.reduce((s, i) => s + i.qty, 0)} items)
          </h4>
          <button className="mini-cart-close" onClick={onClose} aria-label="Close cart">x</button>
        </div>
        <div className="mini-cart-body">
          {cartItems.length === 0 ? (
            <div className="mini-cart-empty">
              <div className="mini-cart-empty-icon">
                <CartIcon className="ui-icon cart-empty-icon" />
              </div>
              <p>Your cart is empty</p>
              <p style={{ marginTop: '0.25rem', fontSize: '0.75rem', color: '#ccc' }}>Add products to get started</p>
            </div>
          ) : (
            <>
              {cartItems.map((item, i) => (
                <div key={i} className="mini-cart-item">
                  <img src={item.img} alt={item.name} />
                  <div className="mini-cart-item-info">
                    <div className="mini-cart-item-name">{item.name}</div>
                    <div className="mini-cart-item-size">{item.size} x {item.qty}</div>
                  </div>
                  <div className="mini-cart-item-price">Rs. {item.price * item.qty}</div>
                </div>
              ))}
              <div className="mini-cart-footer">
                <div className="mini-cart-total">
                  <span>Total</span>
                  <span>Rs. {total}</span>
                </div>
                <a href="/cart" className="btn-primary" style={{ width: '100%', justifyContent: 'center' }}>Proceed to Checkout</a>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
